import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useSession } from '@hooks';

type ProductTooltipProps = {
  description: string,
  isProductMandatory: boolean
};

const languagesVarsCodes = [
  "LANG_neobooking_product_cant_be_removed", //Ne peut être enlevé
]

const ProductTooltip: React.FC<ProductTooltipProps> = ({ description, isProductMandatory }) => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    !isEmpty(description)
      ?
      <Tooltip placement='top' arrow title={<>
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
        {
          isProductMandatory && <span className="tw-font-semibold tw-italic">{getLanguageVarValue("LANG_neobooking_product_cant_be_removed")}</span>
        }
      </>}>
        <span className='tw-ml-2'>
          <InfoOutlined className="tw-text-gray-500" fontSize='small' />
        </span>
      </Tooltip>
      :
      <></>
  );
};

ProductTooltip.propTypes = {
  description: PropTypes.string.isRequired,
  isProductMandatory: PropTypes.bool.isRequired
};

export default ProductTooltip;
